export default {
  apiKey: "AIzaSyCvG0t1jqjjdm_w1zndA2lojQkj0KqfmmE",
  authDomain: "soundpaint-8dio-admin.firebaseapp.com",
  projectId: "soundpaint-8dio-admin",
  storageBucket: "soundpaint-8dio-admin.appspot.com",
  messagingSenderId: "442777528024",
  appId: "1:442777528024:web:11a41039a024d0e77a99ad"
};